function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18",
  height: "18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15.75 12.375V15a.75.75 0 01-.75.75h-1.5a.75.75 0 01-.75-.75v-1.125M5.25 13.875V15a.75.75 0 01-.75.75H3a.75.75 0 01-.75-.75v-2.625",
  stroke: "#22262A",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M2.25 12.375v-2.066c0-.597.237-1.17.66-1.592l.84-.842h10.5l.84.84c.423.423.66.995.66 1.592v2.068a1.5 1.5 0 01-1.5 1.5H3.75a1.5 1.5 0 01-1.5-1.5z",
  stroke: "#22262A",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.75 7.125l-1.5.375M3.75 7.5l-1.5-.375M3.75 7.875v-.38l.627-2.352A1.876 1.876 0 016.19 3.75h5.686c.869 0 1.623.596 1.824 1.44l.55 2.305v.38M4.5 10.875H6M12 10.875h1.5",
  stroke: "#22262A",
  strokeWidth: "1.15",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));